import { SearchLandingContext } from '@/context/SearchLandingContext';
import React, { useEffect, useState, useContext } from 'react';
import LandingPageSearchResults from './landpageSearchResults';

const RecentItemsTabList = () => {
    const [selectedTab, setSelectedTab] = useState<'RecentlyViewed' | 'RecentlyPublished' | 'MyRecentDrafts' | 'MyRecentlyPublished'>('RecentlyViewed')
    const { recentlyViewed, recentlyPublished, myRecentlyPublished, recentDrafts, isLoading, getRecentlyPublished, getRecentDrafts, getHistory, getMyRecentlyPublished } = useContext(SearchLandingContext)

    useEffect(() => {
        switch(selectedTab) {
            case 'RecentlyViewed': 
                getHistory();
                break;
            case 'RecentlyPublished': 
                getRecentlyPublished();
                break;
            case 'MyRecentlyPublished': 
                getMyRecentlyPublished();
                break;
            case 'MyRecentDrafts': 
                getRecentDrafts();
                break;
        }

    },[selectedTab])

    const RecentItems = () => {
        switch(selectedTab) {
            case 'RecentlyViewed': 
                return <LandingPageSearchResults results={recentlyViewed} isLoading={isLoading}/>
            case 'RecentlyPublished': 
                return <LandingPageSearchResults results={recentlyPublished} isLoading={isLoading}/>
            case 'MyRecentlyPublished': 
                return <LandingPageSearchResults results={myRecentlyPublished} isLoading={isLoading}/>
            case 'MyRecentDrafts': 
                return <LandingPageSearchResults results={recentDrafts} isLoading={isLoading} isDraft/>
        }
    }

    return (<>
    <ul className='recent-items-tab-nav'>
        <li className={`recent-item-tab-wrapper ${selectedTab === 'RecentlyViewed' ? 'selected' : ''}`}>
            <button
                className={`recent-item-tab-button ${selectedTab === 'RecentlyViewed' ? 'selected' : ''}`}
                onClick={() => setSelectedTab('RecentlyViewed')}
            >
                Visited Searches
            </button>
        </li>
        <li className={`recent-item-tab-wrapper ${selectedTab === 'RecentlyPublished' ? 'selected' : ''}`}>
            <button
                className={`recent-item-tab-button ${selectedTab === 'RecentlyPublished' ? 'selected' : ''}`}
                onClick={() => setSelectedTab('RecentlyPublished')}
            >
                Recently Published
            </button>
        </li>
        <li className={`recent-item-tab-wrapper ${selectedTab === 'MyRecentlyPublished' ? 'selected' : ''}`}>
            <button
                className={`recent-item-tab-button ${selectedTab === 'MyRecentlyPublished' ? 'selected' : ''}`}
                onClick={() => setSelectedTab('MyRecentlyPublished')}
            >
                My Recently Published
            </button>
        </li>
        <li className={`recent-item-tab-wrapper ${selectedTab === 'MyRecentDrafts' ? 'selected' : ''}`}>
            <button
                className={`recent-item-tab-button ${selectedTab === 'MyRecentDrafts' ? 'selected' : ''}`}
                onClick={() => setSelectedTab('MyRecentDrafts')}
            >
                My Recent Drafts
            </button>
        </li>
    </ul>
    <RecentItems />
    </>)
}

export default RecentItemsTabList;